import { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { FaPlus, FaUser } from 'react-icons/fa';
import api from '../../services/api';
import { getMediaUrl } from '../../services/media';
import styles from '../Books/Books.module.css';

const PAGE_SIZE = 24;

const Persons = () => {
  const [persons, setPersons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [deleteId, setDeleteId] = useState(null);

  const fetchPersons = useCallback((p) => {
    setLoading(true);
    api.get('/persons', { params: { page: p } }).then((res) => {
      setPersons(res.data?.persons || []);
      setTotal(res.data?.total || 0);
    }).catch(() => setPersons([])).finally(() => setLoading(false));
  }, []);

  useEffect(() => { fetchPersons(1); }, [fetchPersons]);

  const handlePage = (p) => {
    setPage(p);
    fetchPersons(p);
  };

  const handleDelete = async () => {
    await api.delete(`/persons/${deleteId}`).catch(() => {});
    setDeleteId(null);
    fetchPersons(page);
  };

  const filtered = persons.filter((p) =>
    p.name?.toLowerCase().includes(search.toLowerCase()) ||
    p.role?.toLowerCase().includes(search.toLowerCase())
  );

  const totalPages = Math.ceil(total / PAGE_SIZE);

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <div className={styles.totalCount}>Всего персон: {total}</div>
        <Link to="/persons/add" className={styles.addBtn}>
          <FaPlus /> Добавить персону
        </Link>
      </div>

      <div className={styles.searchBar}>
        <input
          className={styles.searchInput}
          placeholder="Поиск по имени или роли..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className={styles.tableWrap}>
        {loading ? (
          <div className={styles.loading}>Загрузка...</div>
        ) : (
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Фото</th>
                <th>Имя</th>
                <th>Роль</th>
                <th>Годы жизни</th>
                <th>Действия</th>
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr><td colSpan={5}><div className={styles.empty}>Персоны не найдены</div></td></tr>
              ) : filtered.map((p) => (
                <tr key={p.id}>
                  <td>
                    {p.imageUrl ? (
                      <img src={getMediaUrl(p.imageUrl)} alt={p.name} className={styles.cover} />
                    ) : (
                      <div className={styles.coverPlaceholder}><FaUser /></div>
                    )}
                  </td>
                  <td>{p.name}</td>
                  <td>{p.role || '—'}</td>
                  <td>{p.birthYear ? `${p.birthYear} — ${p.deathYear || 'н.в.'}` : '—'}</td>
                  <td>
                    <div className={styles.actions}>
                      <Link to={`/persons/edit/${p.id}`} className={styles.editBtn}>Изменить</Link>
                      <button className={styles.deleteBtn} onClick={() => setDeleteId(p.id)}>Удалить</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {totalPages > 1 && (
        <div className={styles.pagination}>
          <button className={styles.pageBtn} onClick={() => handlePage(page - 1)} disabled={page === 1}>‹</button>
          {Array.from({ length: totalPages }, (_, i) => i + 1)
            .filter(p => p === 1 || p === totalPages || Math.abs(p - page) <= 2)
            .reduce((acc, p, idx, arr) => {
              if (idx > 0 && p - arr[idx - 1] > 1) acc.push('...');
              acc.push(p);
              return acc;
            }, [])
            .map((p, idx) => p === '...' ? (
              <span key={`dots-${idx}`} className={styles.pageDots}>...</span>
            ) : (
              <button key={p} className={`${styles.pageBtn} ${p === page ? styles.pageBtnActive : ''}`} onClick={() => handlePage(p)}>{p}</button>
            ))
          }
          <button className={styles.pageBtn} onClick={() => handlePage(page + 1)} disabled={page === totalPages}>›</button>
        </div>
      )}

      {deleteId && (
        <div className={styles.modal}>
          <div className={styles.modalBox}>
            <div className={styles.modalTitle}>Удалить персону?</div>
            <div className={styles.modalText}>Это действие нельзя отменить.</div>
            <div className={styles.modalActions}>
              <button className={styles.cancelBtn} onClick={() => setDeleteId(null)}>Отмена</button>
              <button className={styles.confirmDeleteBtn} onClick={handleDelete}>Удалить</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Persons;
